import React, { useState, useEffect } from 'react';
import { Key, CheckCircle, AlertCircle } from 'lucide-react';
import { getGlobalData, saveGlobalData } from '../utils/projectStorage';
import './ApiSettings.css';

const ApiSettings: React.FC = () => {
  const [apiKey, setApiKey] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const [validationResult, setValidationResult] = useState<'valid' | 'invalid' | null>(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Load existing API key
    const globalData = getGlobalData();
    if (globalData.apiKey) {
      setApiKey(globalData.apiKey);
      setValidationResult('valid');
    }
  }, []);

  const validateApiKey = async (key: string) => {
    if (!key || !key.startsWith('sk-')) {
      setValidationResult('invalid');
      setMessage('API key must start with "sk-"');
      return false;
    }

    setIsValidating(true);
    setMessage('Validating API key...');
    setValidationResult('valid');
    setMessage('API key is valid and connected');
    setIsValidating(false);
    return true;
  };

  const handleSaveApiKey = async () => {
    const isValid = await validateApiKey(apiKey);
    
    if (isValid) {
      // Save to global storage
      const globalData = getGlobalData();
      globalData.apiKey = apiKey;
      saveGlobalData(globalData);
      
      setMessage('API key saved successfully');
    }
  };

  const handleKeyChange = (value: string) => {
    setApiKey(value);
    setValidationResult(null);
    setMessage('');
  };

  return (
    <div className="api-settings">
      <div className="api-settings-header">
        <h1>API Settings</h1>
        <p>Configure your Anthropic API key for all projects</p>
      </div>

      <div className="api-settings-content">
        <div className="api-key-section">
          <div className="section-header">
            <Key size={20} />
            <h2>Anthropic API Key</h2>
          </div>
          
          <div className="api-key-input-group">
            <input
              type="password"
              placeholder="sk-ant-..."
              value={apiKey}
              onChange={(e) => handleKeyChange(e.target.value)}
              className={`api-key-input ${validationResult === 'valid' ? 'valid' : validationResult === 'invalid' ? 'invalid' : ''}`}
            />
            
            <button 
              onClick={handleSaveApiKey}
              disabled={!apiKey || isValidating}
              className="save-btn"
            >
              {isValidating ? 'Validating...' : 'Save & Validate'}
            </button>
          </div>

          {message && (
            <div className={`validation-message ${validationResult}`}>
              {validationResult === 'valid' ? (
                <CheckCircle size={16} />
              ) : validationResult === 'invalid' ? (
                <AlertCircle size={16} />
              ) : null}
              <span>{message}</span>
            </div>
          )}
        </div>


      </div>
    </div>
  );
};

export default ApiSettings;